import { render, staticRenderFns } from "./ApplicantRow.vue?vue&type=template&id=68a33b28&scoped=true&"
import script from "./ApplicantRow.vue?vue&type=script&lang=js&"
export * from "./ApplicantRow.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantRow.vue?vue&type=style&index=0&id=68a33b28&scoped=true&lang=css&"
import style1 from "./ApplicantRow.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a33b28",
  null
  
)

export default component.exports